<template>
  <custom-dialog
    width="600px"
    :append-to-body="true"
    :title="title"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$t('dms_edit_route_name_dialog.lu_xian_ming_cheng')"
              prop="mapName"
            >
              <el-input v-model="form.mapName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">
        {{ $t('Common.com_cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >
        {{ $t('dms_edit_route_name_dialog.que_ren') }}
      </el-button>
    </div>

  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {
  },
  props: {
  },
  data() {
    return {
      form: {
        mapName: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        mapName: {
          required: true,
          message: this.$t('Common.com_required')
        }
      };
    },
    title() {
      if (this.dicMap.sbr_slot && this.model.data) {
        const row = this.model.data;
        const { hlcCode, siteName, slotCode } = row;
        const slotCodeName = this.dicMap.sbr_slot[slotCode];
        const str = [hlcCode, siteName, slotCodeName].filter(val => !!val).join('/');
        const tips = this.$t('dms_edit_route_name_dialog.bjlxmco', [str]);
        return tips;
      }
      return '';
    }
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    async onConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const reqData = this.getReqData();
          await this.$postJSON(apis.hlcSlotEditMapName, reqData);
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();

        }
      });
    },
    getReqData() {
      const ret = {
        hlcSlotId: this.model.data.hlcSlotId,
        mapName: this.form.mapName
      };
      return ret;
    },
    init() {
      if (this.model.data && this.model.data.mapName) {
        const mapName = this.model.data.mapName;
        this.form.mapName = mapName;
      }
    }
  },
  created() {
  },
  mounted() {
    this.getDicMap('sbr_slot');
    this.init();
  },
};
</script>

<style>
</style>
